import styled from "styled-components";


export const SoundIconContainer = styled.div`
  background-color: ${props => props.theme.colors.backgroundDark + '99'}; //99 is hexa for 0.6 opacity
  color: ${props => props.theme.colors.buttonLight};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  backdrop-filter: blur(20);

  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
  
  @keyframes enlarge {
    0% {
      transform: scale(0.5);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
    animation: enlarge 300ms forwards;
`;